module.exports = __webpack_public_path__ + "static/media/filledStar.ac9bd69f.svg";